/**
 * useProductDetailAttr
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'

import useProductDetailAttrContext from './product-detail-attr-context'

const useProductDetailAttr = () => {
  const context = useContext(useProductDetailAttrContext)
  return context
}

export default useProductDetailAttr
